import React, { useContext } from 'react';
import {
	PlaceFactory,
	PlaceQuery,
} from '../../../models/factories/PlaceFactory';
import { ExplorerContext } from '../../../application/config';
import PlaceBookmarks from '../../Catalogue/Bookmarks/BookmarkLists/PlaceBookmarks';
import NoResults from './NoResults';
import { useAppSelector } from '../../../state/hooks';
import { selectPrefs } from '../../../state/selectors';
import { shallowEqual } from 'react-redux';
import {
	filterPlacesByAccessibility,
	sortPlacesByPreferences,
} from '../../../models/helpers/preferenceRanking';

type ResultProps = {
	term: string;
};

const PlaceResults: React.FC<ResultProps> = ({ term }) => {
	const AppData = useContext(ExplorerContext);
	const userPrefs = useAppSelector(selectPrefs, shallowEqual);
	const query: PlaceQuery = {
		filter: {
			title: term,
		},
	};
	const all_places = PlaceFactory.filter(
		AppData.features?.all_places ?? PlaceFactory.getEmpty(),
		query,
	);
	const results = PlaceFactory.filter(all_places, query);
	const prioritisedPlaces = sortPlacesByPreferences(
		filterPlacesByAccessibility([...results.places], userPrefs),
		userPrefs,
	);
	return (
		<>
			{prioritisedPlaces.length > 0 && (
				<PlaceBookmarks places={prioritisedPlaces} />
			)}
			{prioritisedPlaces.length === 0 && <NoResults />}
		</>
	);
};

export default PlaceResults;
